import { useParams, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import MovieCard from "@/components/feature/MovieCard";
import { movies, categories } from "@/mocks/movies";

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || "action");

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug) || categories[0];
  const filteredMovies = movies.filter((m) => m.categorySlug === activeSlug);

  const categoryJsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": `光棍影院 - ${currentCategory.name}`,
    "description": `光棍影院${currentCategory.name}频道，免费高清${currentCategory.name}在线观看，海量${currentCategory.name}资源每日更新。`,
    "url": `https://www.guanggunyingyuan.com/category/${activeSlug}`,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(categoryJsonLd) }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: currentCategory.name },
              ]}
            />
            <div className="px-4 md:px-6 pb-6">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${currentCategory.icon} text-lg`}></i>
                </div>
                <div>
                  <h1 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                    {currentCategory.name}
                  </h1>
                  <p className="text-sm text-foreground-500">{currentCategory.description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full px-4 md:px-6 py-4 border-b border-background-200 bg-background-50 overflow-x-auto">
          <div className="max-w-7xl mx-auto flex items-center gap-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                  activeSlug === cat.slug
                    ? "bg-primary-500 text-white"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="w-full px-4 md:px-6 py-8 md:py-10">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <p className="text-sm text-foreground-500">
                共找到 <strong className="text-foreground-900">{filteredMovies.length}</strong> 部{currentCategory.name}
              </p>
            </div>
            {filteredMovies.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 md:gap-4">
                {filteredMovies.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                  <i className="ri-film-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">暂无该分类的电影资源</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}